import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import OnboardingStepUploadDocumentsUi from '../ui/screens/onboarding-step-upload-documents.ui';
import { RootStoreContext } from '../../core/root-store';

const OnboardingStepUploadDocumentsContainer = observer(() => {
  const rootStore = useContext(RootStoreContext);
  const store = rootStore.onboardingStore;
  const stepErrors = store.shouldShowStepErrors;
  const jobPosition = store.formData.webOnboarding?.appliedFor;
  const isAppliedForPosition = jobPosition ? jobPosition.length > 0 : false;

  const handleCvUploadError = (error: string | null) => {
    store.setVerificationDocumentError('verificationCV', error);
  };

  return (
    <OnboardingStepUploadDocumentsUi
      linkedinLink={store.formData.verification?.linkedInProfileUrl}
      linkedinLinkError={stepErrors.linkedInProfileUrl}
      cvError={stepErrors.verificationCV}
      cvDescriptionError={stepErrors.verificationCvDescription}
      cvDescription={store.formData.verification?.verificationCvDescription}
      isAppliedForPosition={isAppliedForPosition}
      isSubmitting={store.isSavingStep}
      onUpdateVerificationField={store.updateVerificationField}
      onSetVerificationDocument={store.addVerificationDocument}
      onCvUploadError={handleCvUploadError}
      hasCvUploaded={!!store.formData.verification?.verificationCV || store.verificationDocuments.has('verificationCV')}
      currentCvFileName={store.verificationDocuments.get('verificationCV')?.selectedFile?.name}
    />
  );
});

export default OnboardingStepUploadDocumentsContainer;
